import { useQuery } from 'react-query';
import { fetchInvoices } from '../services';

const useFetchInvoices = orderId => {
  const placeholderData = {
    paginationData: { data: [], pagination: {} },
    suppliersCount: 0,
  };

  const { isLoading, isPlaceholderData, data, refetch } = useQuery(
    ['getInvoices', orderId],
    () => fetchInvoices(orderId),
    {
      placeholderData,
      enabled: !!orderId,
    }
  );

  const { paginationData, suppliersCount } = data || {
    paginationData: { data: [], pagination: {} },
    suppliersCount: 0,
  };

  return {
    invoices: paginationData?.data,
    suppliersCount,
    invoicesCount: paginationData?.pagination?.totalData,
    pagination: paginationData,
    isLoading: isLoading || isPlaceholderData,
    refetch,
  };
};

// eslint-disable-next-line import/prefer-default-export
export { useFetchInvoices };
